var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticClass: "navbar position-absolute",
          attrs: { toggleable: "lg" }
        },
        [
          _c("b-navbar-brand", { attrs: { href: "/" } }, [
            _c("img", {
              staticClass: "navbar-brand-img",
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    {
                      staticClass: "my-auto",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/abogados")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("openlegal.menu.are-you-lawyer")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticClass: "my-auto",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/openlegal360/empresas")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("openlegal.menu.business")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticClass: "my-auto mr-0 mr-md-5",
                      attrs: { href: "https://blog.opensalud.es/" }
                    },
                    [_vm._v("Blog")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    { staticClass: "my-auto nav-lang" },
                    [
                      _c("lang-selector", {
                        staticClass:
                          "d-inline-block pt-lg-0 pt-3 pb-lg-0 pb-2 mr-0"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { display: "contents" } },
                    [
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { blue: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push("/inicio-sesion")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("openlegal.menu.sign-in")))
                              ]),
                              _vm._v(" "),
                              _c("base-icon", {
                                staticClass: "ml-2",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                  color: _vm.$uiHelpers.isMobile
                                    ? _vm.ORANGE_COLOUR
                                    : "white"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("openlegal-search-block"),
      _vm._v(" "),
      _c("openlegal-cards-slider-home"),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert py-0 my-lg-5 my-0",
          attrs: { id: "lawyers-block" }
        },
        [
          _c(
            "b-col",
            { staticClass: "my-auto content", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("openlegal.are-you-lawyer")))]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c("div", { staticClass: "logo-block mt-5" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("openlegal.lawyer-block-description")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "d-inline-block" }, [
                    _vm._v(_vm._s(_vm.$t("openlegal.sign-up-in")))
                  ]),
                  _c("img", {
                    staticClass: "d-inline-block ml-2 mb-3",
                    attrs: {
                      src:
                        "/static-appopensalud/img/logos/openlegalpro_white.svg"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "mt-5",
                  attrs: { white: "", outline: "" },
                  on: {
                    click: function($event) {
                      return _vm.$helpers.goToSection("contact-form")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("openlegal.menu.sign-in")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "py-0 py-lg-5 bg-reduced",
              attrs: { md: "12", lg: "6" }
            },
            [_c("div", { staticClass: "col-bg ml-lg-auto" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section reverse-sm", attrs: { id: "security-data" } },
        [
          _c("b-col", { staticClass: "pr-5", attrs: { md: "12", lg: "6" } }, [
            _c("div", { staticClass: "col-bg ml-lg-auto" })
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "content my-auto pl-0 pl-md-5",
              attrs: { md: "12", lg: "6" }
            },
            [
              _c("h3", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.$t("openlegal.security-privacity")))
              ]),
              _vm._v(" "),
              _c("h5", { staticClass: "p-0" }, [
                _vm._v(_vm._s(_vm.$t("openlegal.security-subtitle")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("openlegal.security-text1")))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "subtitle",
                  staticStyle: { "margin-bottom": "7rem" }
                },
                [_c("p", [_vm._v(_vm._s(_vm.$t("openlegal.security-text2")))])]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass: "cert-icons",
                  staticStyle: { display: "initial" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "inline-block" } },
                    [_c("ISO27001Logo")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { display: "inline-block" } }, [
                    _c("img", {
                      staticClass: "vertical",
                      attrs: {
                        src:
                          "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
                      }
                    })
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("openlegal-video-service"),
      _vm._v(" "),
      _c("companies-contact-form", {
        staticClass: "pb-5 pb-md-0",
        attrs: {
          id: "contact-form",
          title: _vm.$t("openlegal.explain-case"),
          showDescription: "",
          subtitle: _vm.$t("openlegal.contact-form.text"),
          serviceType: _vm.$t("legal-services"),
          forIndividualsOnly: "",
          platform: "Openlegal",
          productName: "Openlegal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f9f8ba0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9f8ba0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/Home.vue
// module id = 4353
// module chunks = 40